import React, {Component} from 'react';
import PropTypes from 'prop-types';

class Toggle extends Component {
	onChange(e) {
		e.stopPropagation();
		this.props.onChange(!this.props.checked);
	}

	render() {
		return (
			<label className={'toggle-component' + (this.props.locked ? ' locked' : '')}>
				<input
					type="checkbox"
					onChange={this.props.locked ? null : this.onChange.bind(this)}
					checked={this.props.checked}
					aria-label={this.props.ariaLabel}
				/>
				<span className="slider round" />
			</label>
		);
	}
}
Toggle.propTypes = {
	onChange: PropTypes.func.isRequired,
	checked: PropTypes.bool.isRequired,
	locked: PropTypes.bool,
	// Optional accessible name for the checkbox this renders. The control shows no text of its own —
	// a caller relying on nearby visible text alone leaves it announced as just "checkbox, not
	// checked". Undefined by default, so every existing caller renders exactly as before.
	ariaLabel: PropTypes.string,
};
export default Toggle;
